export default async function mswStarterLogic() {
	const isDev =
		process.env.NODE_ENV === 'development' ||
		(typeof window !== 'undefined' &&
			window.location.hostname === 'localhost');

	if (isDev && typeof window !== 'undefined') {
		if (window.location.pathname === '/fitness') {
			window.location.pathname = '/fitness/';
			return Promise.resolve();
		}
		const { worker } = await import('../mocks/browser');
		await worker.start({
			serviceWorker: {
				url: '/fitness/mockServiceWorker.js',
			},
		});
	}
	return Promise.resolve();
}
